import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink, Link } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, BottoneAPI, CampoNumero, CampoJSON, CampoData, TextEditor } from '../components/';

interface INewsState {
    Dato: Dati.CRisAPIDatoTipiInfoNews;
    ID_News: number;
    UpdatePage: number;
}

export class News extends BaseComponent<Glob.IRouteGlobaleProps, INewsState> {
    

    constructor(props: any) {
        super(props);
        this.state = { Dato: new Dati.CRisAPIDatoTipiInfoNews(), ID_News: (this.props.match.params as any).ID_News, UpdatePage:1 };
        this.OnErrore = this.OnErrore.bind(this);
        this.OnChange = this.OnChange.bind(this);
    }

    private OnRis = (sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfoNews, datiNuovi: boolean): React.ReactNode => {
    if (datiNuovi) {
        this.setState({ Dato: dati, ID_News: dati.Dato.ID_News });
        let menu = 0;
        if (dati.Dato.ID_News > 0) {
            menu = 10;
            }
        }
        return false;
    }

    private OnErroreBottoneAPI = (sender: BottoneAPI, errore: Error) => {
        Glob.InfoModaleError(Trad.Trad("NOTIZIA ERRORE"), errore.message);
    }

    private OnClickSalva = (sender: BottoneAPI, dati: Dati.CRisAPI) => {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("NEWS ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("NEWS"), "Your news were saved");
            this.setState({ ID_News: dati.ID_Chiave });
            this.props.history.replace("/news/" + dati.ID_Chiave);
        }
    }

    private OnInvioSalva = (sender: BottoneAPI): any => {
        var Ingr = new Dati.CIngrAPITipi<Dati.CNews>();
        Ingr.Dato = this.state.Dato.Dato;
        Ingr.Tipi = this.state.Dato.Tipi;
        return Ingr;
    }

    public render() {
        let Accessibility: string = "hidden";
        if (Glob.AzioneAbilitata("NewsController", Glob.Scrittura))
            Accessibility = "";

        return (
            <div className="kt-portlet">
               <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon "><i className="fa fa-users"></i></span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Notizia")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                <a href="/news/0" className={"kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" + Accessibility} title={Trad.Trad("Nuovo")} onClick={() => {this.setState({UpdatePage: this.state.UpdatePage + 1, ID_News: 0})}}>
                                    <i className="fa fa-plus"></i>
                                </a>
                            </div>
                        </ul>
                    </div>
                </div>

                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">

                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row dashed-border-bottom">
                            <div className="col-lg-3">
                                <label>ID</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.ID_News || ""} name="Dato.ID_News" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <label className="">{Trad.Trad("Titolo")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.Dato.Dato.Title || ""} name="Dato.Title" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <label className="">{Trad.Trad("Categoria")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.Dato.Dato.Category || ""} name="Dato.Category" onChange={(e) => { this.OnChange(e) }} />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <label className="">{Trad.Trad("DataNotizie")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData ValoreInArrivo={this.state.ID_News > 0} Name="Dato.NewsDate" Id="Dato.NewsDate" Valore={this.state.Dato.Dato.NewsDate} OnChange={this.OnChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row dashed-border-bottom">
                            <label className="">{Trad.Trad("Descrizione")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <TextEditor  description={this.state.Dato.Dato.Description} visibility={Accessibility} Name="Dato.Description" Id="Dato.Description" OnChange={this.OnChange}/>
                            </div>
                        </div>
                    </div>

                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <ChiamaAPI Aggiornare={this.state.UpdatePage} URL={"/api/News?ID_News=" + this.state.ID_News} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                    <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/News/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} />
                                    <button className={"btn btn-secondary " + Accessibility} onClick={history.back} style={{ marginLeft: 5 }}>{Trad.Trad("Annulla")}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        );
    }

    
}



// WEBPACK FOOTER //
// ./src/form/News.tsx